import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CloneEvent($id: ID!, $companyId: ID!, $attributes: EventAttributes!) {
    cloneEvent(id: $id, companyId: $companyId, attributes: $attributes) {
      event {
        id
        ...ClonedEvent
      }
      errors {
        path
        message
      }
    }
  }

  fragment ClonedEvent on Event {
    id
    description
    details
    dateOut
    dateStart
    dateEnd
    dateReturn
    warehouse { id name address }
    venue { id name address }
    client { id clientType { name color } }
    state
  }
`
